import * as yup from 'yup';

export const initialValuesStepOne = {
  // receiverName: 'nobody',
  address: '',
};

export const initialTouchedStepOne = {
  // receiverName: true,
  address: true,
};

export const schemaPropsStepOne = {
  // address: yup.string().required('Requerido'),
};

export const schemaStepOne = yup.object().shape(schemaPropsStepOne);

/*
export const requiredReceiverSchema = yup.object().shape({
  receiverName: schemaPropsStepOne.receiverName,
});
*/
